import { ComponentProps } from "react";
import { Field, FieldDescription, FieldLabel } from "../ui/field";
import { FieldErrors, FieldProps } from "./field";
import { CpySelect } from "@/services/backend/cpy/components/cpy-select";

/*
 * CpySelectField wraps CpySelect in a shadcn/ui
 * Field component.
 */
export function CpySelectField({
  label,
  description,
  errors,
  fieldProps,
  ...props
}: {
  label: string;
} & ComponentProps<typeof CpySelect> &
  FieldProps) {
  return (
    <Field {...fieldProps}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <CpySelect aria-invalid={errors && errors.length > 0} {...props} />
      {description && <FieldDescription>{description}</FieldDescription>}
      <FieldErrors errors={errors} />
    </Field>
  );
}
